module.exports = __webpack_public_path__ + "static/media/gallery-img-9.55a6342b.jpg";